<!-- src/views/home/index.vue -->
 <template>
    <div class="home-page">
        <section class="container news-section">
            <h2>{{ $t('page.home.latestNews') }}</h2>
            <div class="row">
                <div class="col-md-6 col-12 pb-0 pb-md-3 pt-2 pr-md-1">
                    <Slider :slides="latestNews" />
                </div>
                <div class="col-12 col-md-6 pt-2 pl-md-1 mb-3 mb-lg-4">
                    <div class="row news-thumbnails">
                        <div v-for="news in latestNews" :key="news.id" class="col-6 pb-1 pt-0 pr-1">
                            <div class="news-card">
                                <div class="position-relative">
                                    <div class="image-wrapper">
                                        <a :href="news.link" target="_blank">
                                            <img
                                                class="img-fluid w-100"
                                                :src="news.image"
                                                :alt="news.title"
                                            />
                                        </a>
                                    </div>
                                    <div class="info-overlay">
                                        <a class="badge-category" :href="news.categoryLink">{{ news.category }}</a>
                                        <a :href="news.link" target="_blank">
                                            <h3 class="news-title">{{ news.title }}</h3>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  
        <section class="bg-dark statistics-section">
            <div class="container py-5">
                <div class="row gy-3">
                    <StatCard
                        v-for="stat in statistics"
                        :key="stat.id"
                        :icon="stat.icon"
                        :value="stat.value"
                        :label="stat.label"
                    />
                </div>
            </div>
        </section>

        <section class="container about-section">
            <div class="row">
                <div class="col">
                    <h2>{{ $t('page.home.aboutUs') }}</h2>
                    <p>{{ aboutSystem.description }}</p>
                    <h2>{{ $t('page.home.mostSearched') }}</h2>
                    <div class="row">
                        <AnnouncementCard
                            v-for="announcement in announcements"
                            :key="announcement.id"
                            :announcement="announcement"
                        />
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <h2>{{ $t('page.home.exploreMap') }}</h2>
                    <MapaBrazil />
                </div>
            </div>
        </section>

        <section class="container services-section">
            <h2>{{ $t('page.home.services') }}</h2>
            <div class="row">
                <ServiceCard
                    v-for="service in services"
                    :key="service.id"
                    :icon="service.icon"
                    :label="service.label"
                />
            </div>
        </section>
    </div>
</template>
  
<script>
    import { ref, onMounted } from "vue";
    import { useAnnouncementStore } from "@/stores/announcementStore";
    import AnnouncementCard from "@/components/AnnouncementCard.vue";
    import MapaBrazil from "@/components/MapaBrazil.vue"; 
    import Slider from "@/components/Slider.vue";
    import StatCard from "@/components/StatCard.vue";
    import ServiceCard from "@/components/ServiceCard.vue";
  
    export default {
        name: "Home",
        components: {
            AnnouncementCard,
            MapaBrazil,
            Slider,
            StatCard,
            ServiceCard,
        },
        setup() {        
            const announcementStore = useAnnouncementStore();
            const announcements = ref([]);
            const latestNews = ref([
                {
                    id: 1,
                    title: "Lançamento do Novo Sistema",
                    description: "O novo sistema de gestão de serviços foi lançado com novas funcionalidades!",
                    link: "#",
                    image: "https://s2-autoesporte.glbimg.com/KzeCOpghq6L8K6RT0un3gEShgTo=/5x63:1920x1142/1200x600/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2024/A/C/jbTwdWQRGZ7Q2sQmRy8A/fiat-fastback-hibridos-2025-traseira-dinamica.jpg",
                    category: "Tecnologia",
                    categoryLink: "#",
                    buttonText: "",
                },
                {
                    id: 2,
                    title: "Lançamento do Novo Sistema",
                    description: "O novo sistema de gestão de serviços foi lançado com novas funcionalidades!",
                    link: "#",
                    image: "https://s2-autoesporte.glbimg.com/oDKgrZePtnDXfY5KUuEh09XuRC8=/0x0:1920x1280/1200x600/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2024/A/h/gttDdWTaKrT0ActYGGDg/3-bugatti-w16-mistral-world-record.jpg",
                    category: "Tecnologia",
                    categoryLink: "#",
                    buttonText: "",
                },                
                {
                    id: 3,
                    title: "Lançamento do Novo Sistema",
                    description: "O novo sistema de gestão de serviços foi lançado com novas funcionalidades!",
                    link: "#",
                    image: "https://s2-autoesporte.glbimg.com/XQIOwAQLxPZ6IPIkK78lb2YGeuk=/0x0:1280x720/280x160/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2023/R/p/vK9o2MSAuhVSTcCmzZCw/ame-pneu-careca.png",
                    category: "Tecnologia",
                    categoryLink: "#",
                    buttonText: "",
                },
                {
                    id: 4,
                    title: "Lançamento do Novo Sistema",
                    description: "O novo sistema de gestão de serviços foi lançado com novas funcionalidades!",
                    link: "#",
                    image: "https://s2-autoesporte.glbimg.com/PHOSF9gGl5pAbL6Su8XUEQ3sTFM=/0x0:768x480/280x160/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2023/i/1/pl6qMdQNCa63BUENVuAQ/cnh-nova-768x480.jpg",
                    category: "Tecnologia",
                    categoryLink: "#",
                    buttonText: "",
                },
            ]);
    
            const aboutSystem = ref({
                description: "Nosso sistema permite gerenciar facilmente serviços de instalação elétrica, projetos, orçamentos e muito mais.",
            });

            const statistics = ref([
                { id: 1, icon: "fa-users", value: "60+", label: "Visitantes" },
                { id: 2, icon: "fa-car", value: "60", label: "Anúncios" },
                { id: 3, icon: "fa-shop", value: "60+", label: "Lojistas" },
                { id: 4, icon: "fa-map-location-dot", value: "60+", label: "Cidades" },
            ]);

            const services = ref([
                { id: 1, icon: "fa-soap", label: "Lavagem" },
                { id: 2, icon: "fa-fill-drip", label: "Pintura" },
                { id: 3, icon: "fa-shield-halved", label: "Seguros" },
                { id: 4, icon: "fa-truck-ramp-box", label: "Reboques" },
                { id: 5, icon: "fa-chart-line", label: "Tabela FIPE" },
                { id: 6, icon: "fa-money-check-dollar", label: "Financeiras" },
                { id: 7, icon: "fa-person-chalkboard", label: "Despachantes" },
            ]);

            const loadAnnouncements = async () => {
                await announcementStore.getAllAnnouncements();
                announcements.value = announcementStore.announcements.slice(0, 3);
            };

            onMounted(loadAnnouncements);
    
            return {
                latestNews,
                aboutSystem,
                announcements,
                statistics,
                services,
            };
        },
    };
</script>
  
<style scoped>
.news-thumbnails img {
    max-height: 194px;
    max-width: 272px;
}
.news-thumbnails .b-0 {
    bottom: 0;
}
.news-thumbnails h3 {
	font-size: 1em;
}
.news-thumbnails .bg-shadow {
    background: rgba(76, 76, 76, 0);
    background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(179, 171, 171, 0)), color-stop(49%, rgba(48, 48, 48, 0.37)), color-stop(100%, rgba(19, 19, 19, 0.8)));
    background: linear-gradient(to bottom, rgba(179, 171, 171, 0) 0%, rgba(48, 48, 48, 0.71) 49%, rgba(19, 19, 19, 0.8) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4c4c4c', endColorstr='#131313', GradientType=0 );
}
.news-thumbnails .top-indicator {
    bottom: inherit;
    left: inherit;
    margin-right: 1rem;
    right: 0;
    top: 1rem;
}
.news-thumbnails .overflow {
    position: relative;
    overflow: hidden;
}
.news-thumbnails .zoom img {
    transition: all 0.2s linear;
}
.news-thumbnails .zoom:hover img {
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
}
</style>
  